
export { default as TabChatNormalIcon } from "./tab_icon_chats_normal.svg"
export { default as TabChatPressIcon } from "./tab_icon_chat_press.svg"
export { default as TabCreateNormalIcon } from "./tab_icon_create_normal.svg"
export { default as TabCreatePressIcon } from "./tab_icon_create_press.svg"
export { default as TabExploreNormalIcon } from "./tab_icon_explore_normal.svg"
export { default as TabExplorePressIcon } from "./tab_icon_explore_press.svg"
export { default as TabHomeNormalIcon } from "./tab_icon_home_normal.svg"
export { default as TabHomePressIcon } from "./tab_icon_home_press.svg"
export { default as TabMeNormalIcon } from "./tab_icon_me_normal.svg"
export { default as TabMePressIcon } from "./tab_icon_me_press.svg"